import { Component, Mixins } from 'vue-property-decorator';
import Classes from '@components/shared/mixins/classes';
import config from '@components/shared/config';
import Props from './props';

/**
 * @name Table
 */
@Component({})
class YTable extends Mixins(Props, Classes) {
    /**
     * Props list that active by developer
     */
    activeCommonProps: Array<string> = ['sharp', 'rounded', 'raised', 'bordered', 'dense', 'color'];

    /**
     * Create Common Props for the table.
     *
     * @returns {object} - List of props
     */
    get commonProps(): Record<string, any> {
        const commonProps: Record<string, any> = {
            baseClass: this.baseClass,
        };
        this.activeCommonProps.forEach((item) => {
            commonProps[item] = this[item];
        });
        return commonProps;
    }

    /**
     * Create classes array for the table.
     *
     * @returns {Array} - Array of classes
     */
    get classes(): Array<string> {
        const cls: Array<string> = [];
        cls.push(...this.commonClasses('Table', this.commonProps, this.baseClass || config.prefix.table));
        if (this.striped) {
            if (this.stripedType === 'column') {
                cls.push('is-striped-column');
            } else if (this.stripedType === 'row') {
                cls.push('is-striped-row');
            }
            if (this.stripedOdd) {
                cls.push('is-striped-odd');
            }
            if (this.stripedEven || this.defaultStriped) {
                cls.push('is-striped-even');
            }
        }

        if (this.borderedColumn) {
            cls.push('is-border-column');
        }

        if (this.borderedRow) {
            cls.push('is-border-row');
        }

        if (this.headerColor) {
            cls.push(`is-header-color--${this.headerColor}`);
        }

        if (this.noBorder) {
            cls.push('has-no-border');
        }

        return cls;
    }

    /**
     * Set default for striped background color
     *
     * @returns {boolean}
     */
    get defaultStriped(): boolean {
        return this.striped && !this.stripedOdd && !this.stripedEven;
    }

    /**
     * The css parent class of the component
     */
    parentClass: string = this.componentClass(this.baseClass, config.prefix.table);
}

export default YTable;
